module.exports = __webpack_public_path__ + "img/Raj.d6ddf842.jpg";